var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import { ZdsCard } from '@zig-design-system/ui-components-react';
import Translation from '../../../Shared/components/Translation';
import { RootContext } from '../../../Context/RootContext';
export const createProjectSubheadLine = (project) => {
    let subheadLineParts = [];
    if (project.city) {
        subheadLineParts.push(project.city);
    }
    if (project.quarter) {
        subheadLineParts.push(project.quarter);
    }
    return subheadLineParts.join(', ');
};
const Project = ({ project, url, index }) => {
    const settings = useContext(RootContext).pluginContext;
    const assetPaths = useContext(RootContext).assetPaths;
    const [imageExists, setImageExists] = useState(true);
    useEffect(() => {
        const checkImageExists = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch(project.list_image);
                if (!response.ok) {
                    setImageExists(false);
                }
            }
            catch (error) {
                setImageExists(false);
            }
        });
        checkImageExists();
    }, []);
    const imageSrc = imageExists ? project.list_image : assetPaths.sitepackage + '/Images/imagenotfound_16x9.jpg';
    return (React.createElement("div", { className: 'sm:zds-col-6 md:zds-col-4 zds-flex' +
            (settings.itemsPerRow == '2' && index % 2 != 0 ? ' md:zds-offset-2' : '') },
        React.createElement(ZdsCard, { className: "zds-flex-1", link: url },
            React.createElement("img", { width: "454", height: "341", slot: "media", src: imageSrc, alt: project.name, loading: "lazy" }),
            project.status && React.createElement("div", { slot: "status" }, project.status),
            React.createElement("div", { slot: "header", className: "zds-padding-bottom-3" }, project.name),
            React.createElement("div", { slot: "subheader", className: "zds-subheadline-md" }, createProjectSubheadLine(project)),
            React.createElement("div", { slot: "body", className: "zds-padding-top-1" },
                project.number_of_houses && (React.createElement("div", { className: "zds-light" },
                    React.createElement(Translation, { item: "tx_zigrealestate.number_of_dwellings" }),
                    ": ",
                    project.number_of_houses)),
                project.house_type && React.createElement("div", { className: "zds-light" }, project.house_type)))));
};
export default Project;
